import { AppContext } from 'context/app-context';
import { useContext } from 'react';
import { ContributorsSection } from './components/contributors-section';
import { OwnerSection } from './components/owner-section';
import { QrCodeSection } from './components/qr-code-section';
import { SubscriptionSection } from './components/subscription-section/subscription-section';
import { ReminderSection } from './components/reminder-section';
import { VaultSection } from './components/vault-section';
import styles from './about-vault.module.scss';

type AboutVaultProps = {
  vault: VaultType;
  refetchVault: () => Promise<void>;
};

const AboutVault = ({ vault, refetchVault }: AboutVaultProps) => {
  const {
    state: {
      data: { user },
    },
    dispatch,
  } = useContext(AppContext);

  const isOwner = user.id === vault.owner.id;
  const isOwnerOrContributor =
    isOwner || vault.contributors.some((c) => c.id === user.id);

  return (
    <div className={styles.aboutVault}>
      <div className={styles.firstColumn}>
        <VaultSection
          vault={vault}
          isOwner={isOwner}
          refetchVault={refetchVault}
        />
        <SubscriptionSection vault={vault} isOwner={isOwner} />
      </div>

      <div className={styles.secondColumn}>
        <OwnerSection vault={vault} isOwner={isOwner} />
        <ContributorsSection
          generalDispatch={dispatch}
          vault={vault}
          isOwner={isOwner}
          refetchVault={refetchVault}
        />
        {isOwnerOrContributor && <ReminderSection vault={vault} />}
        <QrCodeSection vault={vault} />
      </div>
    </div>
  );
};

export { AboutVault };
